var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedcross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5565 0.428062C18.5565 0.192628 18.3639 0 18.1284 0L14.5969 0.0160533L9.27824 6.35672L3.96492 0.0214044L0.428062 0.0053511C0.192628 0.0053511 0 0.192628 0 0.433413C0 0.535078 0.0374551 0.631392 0.101664 0.711654L7.06302 9.00535L0.101664 17.2937C0.0370075 17.3721 0.0011324 17.4703 0 17.5719C0 17.8074 0.192628 18 0.428062 18L3.96492 17.9839L9.27824 11.6433L14.5916 17.9786L18.1231 17.9946C18.3585 17.9946 18.5511 17.8074 18.5511 17.5666C18.5511 17.4649 18.5137 17.3686 18.4495 17.2883L11.4988 9L18.4602 0.706303C18.5244 0.631392 18.5565 0.529726 18.5565 0.428062Z",
    fill: "#EE4143"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedcross);
export default __webpack_public_path__ + "static/media/redcross.1205e9174e16978a8d62f2a71724f2f7.svg";
export { ForwardRef as ReactComponent };